module.exports = __webpack_public_path__ + "img/spain-other-heart-diseases-male.b7c51ab2.png";